import Section from './section';

export default Section;
export { Section };
